import { useState, useCallback } from 'react';
export function useDrop(onDropData) {
    // whether or not something is being dragged over the dropzone
    var _a = useState(false), activated = _a[0], setActivated = _a[1];
    // handle various drag events
    var onDropEvent = useCallback(function (e) {
        e.preventDefault();
        e.stopPropagation();
        setActivated(e.type === 'dragenter' || e.type === 'dragover');
        if (e.type === 'drop') {
            onDropData(e.dataTransfer);
        }
    }, [onDropData]);
    return { onDropEvent: onDropEvent, activated: activated };
}
//# sourceMappingURL=useDrop.js.map